import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'web-ui-components/lib/atoms/iconography';

export const TransactionMoreDetailsButton = ({ onClick }) => (
  <button
    className="c-btn--link"
    aria-label="more-transaction-details"
    data-test-id="more-transaction-details"
    onClick={onClick}
  >
    <Icon iconType="ChevronRightSolidSmall" size="sm" />
  </button>
);

TransactionMoreDetailsButton.propTypes = {
  onClick: PropTypes.func,
};
